import { breakpoints } from './breakpoints';
import { colors } from './colors';
import * as components from './components';
import { semanticTokens } from './semanticTokens';
import { space } from './space';
import { styles } from './styles';
import { textStyles } from './textStyles';
export const theme = {
    config: {
        initialColorMode: 'light',
        useSystemColorMode: false,
    },
    components: {
        ...components,
    },
    space,
    colors,
    styles,
    textStyles,
    breakpoints,
    semanticTokens,
};
